// extracted by mini-css-extract-plugin
export default {"savings-badge-text":"qpeD15","savingsBadgeText":"qpeD15","strikethrough-price":"_jP1Ai","strikethroughPrice":"_jP1Ai","savings-badge":"TeS4DJ","savingsBadge":"TeS4DJ"};